import { ApiManager } from '../../core/api-manager';
import { DataManager } from '../../core/data-manager';
import { settings } from '../../config/settings';
import { LanguageProvider } from '../../core/language-provider';
import { toast } from 'react-toastify';



export async function preInsert(entity, data) {

    var d = { ...data }

    if (entity === 'sample') {
        d.sample1 = 'test'
    }
    if (entity === 'event') {
        console.log('preInsert', data)
        if (data.groups && data.groups.length === 0) {
            toast.error("Impossibile creare l'evento perché non é stato associato nessun gruppo.", { theme: 'colored' });
            return {
                success: 0,
                message: ''
            }
        }
    }
    if (entity === 'course') {
        console.log('preInsert', data)
        if (data.groups && data.groups.length === 0) {
            toast.error("Impossibile creare il corso perché non é stato associato nessun gruppo.", { theme: 'colored' });
            return {
                success: 0,
                message: ''
            }
        }
    }
    if (entity === 'publication') {
        console.log('preInsert', data)
        if (data.groups && data.groups.length === 0) {
            toast.error("Impossibile creare la publicazione perché non é stato associato nessun gruppo.", { theme: 'colored' });
            return {
                success: 0,
                message: ''
            }
        }
    }

    return {
        success: 1,
        data: d,
        message: ''
    }
}